export const propiedadesDlCl = () => {
    return {
        id: null,
        id_animal: null,
        id_propiedades: null,
        id_um_dl_50_oral: null,
        dl_50_oral: null,
        id_um_dl_50_cutanea: null,
        dl_50_cutanea: null,
        id_um_cl_50: null,
        cl_50: null,
        unidad_dl50_oral: {
            lista: ''
        },
        unidad_dl50_cutanea: {
            lista: ''
        },
        unidad_cl50: {
            lista: ''
        },
        error: false
    };
};


export const defaultPropiedades = () => {
    return {
        id_producto: null,
        id_presentacion: null,
        ph_rango: 0,
        ph: null,
        ph_hasta: null,
        incompatibilidades: null,
        flash_point_rango: 0,
        id_um_flash_point: null,
        flash_point: null,
        flash_point_hasta: null,
        id_um_presion_vapor: null,
        presion_vapor: null,
        id_um_temperatura_autoignicion: null,
        temperatura_autoignicion: null,
        concentracion: null,
        lel: null,
        uel: null,
        medios_extincion_adecuados: null,
        medios_extincion_no_adecuados: null,
        peso_molecular: null,
        punto_ebullicion_rango: 0,
        id_um_punto_ebullicion: null,
        punto_ebullicion: null,
        punto_ebullicion_hasta: null,
        punto_fusion_rango: 0,
        id_um_punto_fusion: null,
        punto_fusion: null,
        punto_fusion_hasta: null,
        gravedad_especifica: null,
        id_unidad_densidad: null,
        densidad: null,
        id_um_viscosidad: null,
        viscosidad: null,
        densidad_vapor_relativa: null,
        propiedades_dl_cl: [
            propiedadesDlCl()
        ],
        presentacion: {
            lista: ''
        },
        unidad_flash_point: {
            lista: ''
        },
        unidad_presion_vapor: {
            lista: ''
        },
        unidad_temperatura_autoignicion: {
            lista: ''
        },
        unidad_punto_ebullicion: {
            lista: ''
        },
        unidad_punto_fusion: {
            lista: ''
        },
        unidad_viscosidad: {
            lista: ''
        }
    };
};

export default {
    propiedades: defaultPropiedades(),
    lista_temporal: [],
    presentaciones: [],
    tipos_de_empaque: [],
    unidades_de_temperatura: [],
    capacidades: [],
    unidades_de_presion: [],
    unidades_de_viscosidad: [],
    opciones_dl50: [],
    opciones_cl50: [],
    unidadesDensidad: [],
    opciones_superficies_expuestas: [],
    clases_de_procedimiento: [],
    clases_de_pulverulencia: [],
    unidades_de_medida_tlv: [],
    animales: []
};
